import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"

function Salary() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [items, setItems] = useState([{
    id: 0, employee: "7", date: "50", price: "10000", description: "أحمد", status: "تاخير عن العمل", Total: "4444", phone: "Over Time"
  },
  {
    id: 1, employee: " 8", price: "15000", date: "100", description: "أحمد", status: "تاخير عن العمل", Total: "4444", phone: "Over Time"
  },
  {
    id: 2, employee: " 9", price: "20000", date: "150", description: "أحمد", status: "تاخير عن العمل", Total: "4444", phone: "Over Time"
  }
  ])

  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.employee,
    currentLocal.home.Salary,
    currentLocal.home.Discounts,
    currentLocal.home.Incentives,
    currentLocal.home.Bonuses,
    currentLocal.home.Reasonfordiscount,
    currentLocal.home.Reasonforrewards,
    



  ]
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <div className="d-flex flex-column w-100">

          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.Salariesprice + " " + "7 - 2025"} />


            <p className="w-100 mb-5 fw-bold"> {currentLocal.home.Salariesprice}:150</p>


            <Table
              data={items}
              headerIterm={headerIterm}
            // onDataChanged={getAllApis}
            />


          </div>

        </div>
      </Container>
    </div>)
}

export default Salary